import { createAction } from '@reduxjs/toolkit';

export const addUser = createAction('algolia/add_user');
